var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blur-div',{attrs:{"id":"lite-header","blur":_vm.blur}},[(_vm.avatar.enable)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar.url,"alt":"avatar"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"author"},[_vm._v(_vm._s(_vm.site.author))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.site.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f77182","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/top-header/TopHeader.vue
// module id = null
// module chunks = 